import React, {Component} from 'react';
import {Row, Col} from "reactstrap";
import AnimatedNumber from 'react-animated-number';
import coverImage from './../assets/project.jpg';

import '../css/aboutWebGrade.css';
import axios from "axios";
import {serverPath} from "./common";

class AboutWebGradeComponent extends Component{
    constructor(props){
        super(props);

        this.state = {
            usersCnt : 0,
            problemsCnt: 0,
            submissionsCnt: 0
        }
    }

    componentDidMount() {
        axios.get(serverPath + "problemsService.php", { params: { action: 'getStats' } })
            .then((response) => {
                if (response.data !== null) {
                    this.setState({
                        usersCnt: parseInt(response.data.usersCnt, 10),
                        problemsCnt: parseInt(response.data.problemsCnt, 10),
                        submissionsCnt: parseInt(response.data.submissionsCnt, 10)
                    });
                }
            });
    }

    render(props){
        return (
            <div className='col-md-8 offset-2'>
                <br/>

                <div>
                    <h4 className='subtitle'> ...Od studentskog projekta do platforme koju danas koristi preko 1000 studenata računarstva i informatike... </h4>
                    <img src={coverImage} width={'100%'} alt={"O projektu"}/>
                </div>

                <hr className='yellowDivider'/>

                <div className='aboutUsDiv'>
                    <h3 className='subtitle'> Idejni projekat </h3>
                    <ul>
                        <li> Prototip projekta je nastao 2015. godine </li>
                        <li> Projekat je podeljen na dve velike i nezavisne celine
                            <ol>
                                <li> Ocenjivač
                                    <ul>
                                        <li> Proverava da li studentska rešenja prolaze zadate test primere, kao i da li zadovoljava postavljena vremenska i memorijska ograničenja</li>
                                        <li> Ispis rezultata može biti na standardnom izlazu, standardnom izlazu za greške ili u datotekama</li>
                                        <li> Ulaz u program se može zadati na standardni ulaz, kao argument komandne linije ili u datotekama (proizvoljnoj strukturi direktorijuma)</li>
                                        <li> Izlazi se mogu porediti na jednakost, na zadatu tačnost, ali se može zadati i regularni izraz koji označava
                                            šta sve treba ignorisati pri poredjenju rezultata (na primer beline). </li>
                                        <li> Omogućeno je i automatsko ocenjivanje zadataka iz gradiva Operavivnih sistema (provera prava pristupa, vremena modifikacije, vrednosti
                                            smeštenih u deljenoj memoriji i slično). </li>
                                    </ul>
                                </li>
                                <li> Veb platforma
                                    <ul>
                                        <li> Omogućava komunikaciju sa ocenjivačem i prikaz povratnih informacija o tačnosti rešenja.</li>
                                        <li> Na početku se koristila samo na kursu Programiranje 1 za opšte smerove.</li>
                                        <li> Naredne godine su dodati zadaci za kurs Operativnih sistema. </li>
                                    </ul>
                                </li>
                            </ol>
                        </li>
                        <li> U toku 2016. i 2017. godine testirane su do tada implementirane funkcionalnosti i prikupljane su povratne informacije od
                            studenata o tome u kom smeru treba nastaviti razvoj sistema.</li>
                    </ul>
                </div>

                <hr className='yellowDivider'/>

                <div className='aboutUsDiv'>
                    <h3 className='subtitle'> Revizije sistema </h3>
                    <ul>
                        <li> Prva velika izmena na sistemu je radjena u toku leta 2018. godine.
                            <ul>
                                <li> Studentima je omogućen pregledniji uvid u sadržaje kurseva</li>
                                <li> Ubačena je opcija pregleda test primera na kom rešenje ne daje tačan izlaz</li>
                                <li> Ubačena je opcija slanja zahteva nastavniku da pogleda kod, kao i pregleda komentara koje su nastavnici ostavili na kodovima</li>
                                <li> Nastavnicima je omogućeno da imaju uvid u sva rešenja koja su studenti slali i da postavljaju komentare na njihove kodove. </li>
                                <li> Dodati su zadaci za kurseve Programiranje 1 i Programiranje 2 na informatičkom smeru (oko 200 zadataka ukupno)</li>
                            </ul>
                        </li>
                        <li> Na kraju ove školske godine, studenti su opet popunjavali ankete i dali nove sugestije šta bi sve moglo da se unapredi.</li>
                        <li> Sledeća velika izmena je radjena u toku leta 2019. godine.
                            <ul>
                                <li> Studentima je omogućeno da imaju detaljniji uvid u test primere na kursu Operativnih sistema</li>
                                <li> Omogućena je prijava grešaka u zadacima</li>
                                <li> Dodata je opcija da se poništi zahtev za pregled koda koji je ranije poslat</li>
                                <li> Nastavnicima je omogućeno potpuno upravljanje kursevima i zadacima koji su pridruženi tim kursevima</li>
                                <li> Ubačena je sekcija sa algoritamskim zadacima i dodati su zadaci sa takmičenja Matf2018++</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <hr className='yellowDivider'/>

                <div className='aboutUsDiv'>
                    <h3 className='subtitle'> Danas </h3>
                    <Row style={{'text-align': 'center'}}>
                        <Col>
                            <h4> Broj zadataka </h4>
                            <span className="fa fa-list-alt fa-5x"> </span> <br/>
                            <AnimatedNumber component="text" value={this.state.problemsCnt}
                                            style={{
                                                transition: '0.8s ease-out',
                                                fontSize: 48,
                                                transitionProperty: 'background-color, color, opacity'
                                            }}
                                            duration={3000}
                                            stepPrecision={0}/>
                        </Col>
                        <Col>
                            <h4> Broj korisnika </h4>
                            <span className="fa fa-user fa-5x"> </span> <br/>
                            <AnimatedNumber component="text" value={this.state.usersCnt}
                                            style={{
                                                transition: '0.8s ease-out',
                                                fontSize: 48,
                                                transitionProperty: 'background-color, color, opacity'
                                            }}
                                            duration={3000}
                                            stepPrecision={0}/>
                        </Col>
                        <Col>
                            <h4> Broj poslatih rešenja </h4>
                            <span className="fa fa-code fa-5x"> </span> <br/>
                            <AnimatedNumber component="text" value={this.state.submissionsCnt}
                                            style={{
                                                transition: '0.8s ease-out',
                                                fontSize: 48,
                                                transitionProperty: 'background-color, color, opacity'
                                            }}
                                            duration={3000}
                                            stepPrecision={0}/>
                        </Col>
                    </Row>
                </div>

                <hr className='yellowDivider'/>

                <div className='aboutUsDiv'>
                    <h3 className='subtitle'> Naredni koraci </h3>
                    <ul>
                        <li> Povećevanje broja zadataka</li>
                        <li> Saradnja sa kompanijama </li>
                        <li> Organizovanje "WebGrade Challenge-a" - online mini takmičenja namenjena studentima svih godina studija. Neka takmičenja će biti
                        opšta, neka će biti tematska. Neka takmičenja će organizovati WebGrade tim samostalno, dok će neka biti organizovana u saradnji sa
                        kompanijama. Cilj ovih takmičenja jeste da se studenti oprobaju u rešavanju zadataka koji nisu vezani za kurseve, a koji testiraju
                        znanja koja će im u budućnosti biti korisna za zaposlenje. Izmedju ostalih, ovde će se naći i zadaci sa intervjua u raznim komapnijama.
                        Sva takmičenja će biti unapred najavljena, a prvo nas očekuje već početkom 2020. godine. </li>
                    </ul>
                </div>

                <br/>
            </div>
        );
    }
}

export default AboutWebGradeComponent;